import { getPartnerUsersList } from '@common/api/account';
import { ResellerMemberListResponse } from '@common/api/account/types';
import { PartnerQueryKeys } from '@common/types/query-keys';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

type Params = {
  page: number;
  search?: string;
};

export const useGetPartnersUserList = ({ page = 1, search = '' }: Params) => {
  const query = useQuery({
    queryKey: [PartnerQueryKeys.GET_PARTNER_USER_LIST, page, search],
    queryFn: async () => {
      const response = await getPartnerUsersList(page, search);
      return response; // Simplified to always call with search, handling empty search internally
    },
    retry: false
  });

  const partnerUserList = useMemo(() => {
    return query.data as unknown as ResellerMemberListResponse;
  }, [query.data]);

  return { partnerUserList, query };
};
